/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;

